import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { crearSocio } from '../services/sociosService'
import SocioForm from '../components/socios/SocioForm'

function today() {
  const date = new Date()
  const offset = date.getTimezoneOffset() * 60000
  return new Date(date.getTime() - offset).toISOString().slice(0, 10)
}

export default function NuevoSocioPage() {
  const { organizacion } = useAuth()
  const navigate = useNavigate()

  async function handleSubmit(values) {
    const socio = await crearSocio(organizacion.id, values)
    navigate(`/socios/${socio.id}`, { replace: true, state: { message: 'Socio creado correctamente.' } })
  }

  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <div><p className="text-sm font-semibold text-primary">Socios</p><h2 className="mt-1 text-3xl font-bold tracking-tight">Nuevo socio</h2><p className="mt-2 text-text-secondary">Ingresa los datos para registrar un socio en la organización.</p></div>
      <SocioForm initialValues={{ fecha_ingreso: today(), estado: 'activo' }} onSubmit={handleSubmit} onCancel={() => navigate('/socios')} submitLabel="Guardar socio" />
    </div>
  )
}
